import { render } from "./QueueManagement.vue?vue&type=template&id=25859452&scoped=true"
import script from "./QueueManagement.vue?vue&type=script&lang=js"
export * from "./QueueManagement.vue?vue&type=script&lang=js"

import "./QueueManagement.vue?vue&type=style&index=0&id=25859452&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25859452"]])

export default __exports__